import React from 'react'
import { productTypes } from './combineMorningstarfundsReducer.js'
import { updateUrlParams } from '../allProductTypes/allProductTypesReducer.js'
export const renderStars = (rating, count, useMorningstarGroup = false) => {
  const getStars = () => {
    return [1, 2, 3, 4, 5].map((stars) => {
      if (rating >= stars) {
        return (
          <span
            key={'star' + stars}
            aria-hidden="true"
            className="Icon u-textSizeMsrp1 u-textColorBrandLight"
          >
            &#x2605;
          </span>
        )
      } else {
        return (
          <span
            key={'star' + stars}
            aria-hidden="true"
            className="Icon u-textSizeMsrp1 u-textColorBrandLight"
          >
            &#x2606;
          </span>
        )
      }
    })
  }

  let _rating = rating

  if (typeof _rating !== 'number') {
    _rating = _rating ? parseInt(_rating) || 0 : 0
  }

  return (
    <div className="u-textNoWrap">
      {typeof _rating !== 'number' ? (
        _rating
      ) : (
        <>
          {getStars(_rating)}
          {!useMorningstarGroup && (
            <>
              <br />
              <div className="u-textNoWrap">{count || 0} Funds</div>
            </>
          )}
        </>
      )}
    </div>
  )
}

export const renderColumnHeader = (
  column,
  selectedSortDirection = true,
  onClickSort = () => {}
) => {
  return (
    <th
      key={column.name}
      className={column.className + ' u-bgColorBrandDark'}
      role="columnheader"
      aria-label={column.ariaLabel}
      {...(column?.attr || {})}
    >
      {column.button ? (
        <button
          className={column.button.className}
          data-sort={column.button.sort}
          data-sort-type={column.button.sortType}
          data-sort-direction={
            typeof column.button.sortDirection !== 'undefined'
              ? column.button.sortDirection
                ? 1
                : 0
              : selectedSortDirection
                ? 1
                : 0
          }
          onClick={onClickSort}
        >
          {column.content}
        </button>
      ) : (
        <>{column.content}</>
      )}
    </th>
  )
}

export const renderColumnCell = (column, fund) => {
  return (
    <td
      key={column.key + fund.cusip}
      tabIndex="0"
      className={'Table-cell' + (column.cell.className || '')}
    >
      {column.cell.content(fund, column)}
    </td>
  )
}

export const sortFunds = (
  fundsArray,
  selectedSortDirection,
  selectedSortType,
  selectedSort
) => {
  fundsArray.sort((fund1, fund2) => {
    const a = selectedSortDirection ? fund1 : fund2
    const b = selectedSortDirection ? fund2 : fund1

    // Sort by selected sort
    switch (selectedSortType) {
      case 'number': {
        const aValue =
          typeof a[selectedSort] === 'string'
            ? parseFloat(a[selectedSort] === '-' ? 0.0 : a[selectedSort])
            : a[selectedSort]
        const bValue =
          typeof b[selectedSort] === 'string'
            ? parseFloat(b[selectedSort] === '-' ? 0.0 : b[selectedSort])
            : b[selectedSort]

        const numberCompare = aValue < bValue ? -1 : aValue > bValue ? 1 : 0

        // Sort by Fund Name second if necessary (always ascending)
        if (numberCompare) {
          return numberCompare
        } else {
          return (fund1['fundName'] || '').localeCompare(
            fund2['fundName'] || '',
            'en',
            { sensitivity: 'base' }
          )
        }
      }
      case 'array':
        return (a[selectedSort][0] || '').localeCompare(
          b[selectedSort][0] || '',
          'en',
          { sensitivity: 'base' }
        )
      default:
        return (a[selectedSort] || '').localeCompare(
          b[selectedSort] || '',
          'en',
          { sensitivity: 'base' }
        )
    }
  })

  return fundsArray
}

export const getUrlParams = (classOptions, sortData, initState) => {
  const urlParams = new URLSearchParams(window.location.search)
  if (urlParams.has(productTypes.MF) || urlParams.has(productTypes.ETF)) {
    const hasValueInArray = (arr, val) => arr.some((i) => i === val)
    let _mf = [],
      _etf = []
    if (urlParams.has(productTypes.MF)) {
      _mf = urlParams
        ?.get(productTypes.MF)
        ?.split(',')
        ?.filter((i) => hasValueInArray(classOptions[productTypes.MF], i))
    }
    if (urlParams.has(productTypes.ETF)) {
      _etf = urlParams
        ?.get(productTypes.ETF)
        ?.split(',')
        ?.filter((i) => hasValueInArray(classOptions[productTypes.ETF], i))
    }
    sortData({
      selectedClass: {
        [productTypes.MF]: _mf,
        [productTypes.ETF]: _etf,
      },
    })
  } else {
    updateUrlParams(productTypes.MF, initState.selectedClass[productTypes.MF])
    updateUrlParams(productTypes.ETF, initState.selectedClass[productTypes.ETF])
  }
}
